import { Button } from '@/common/ui/Form/Button'
import { Icon } from '@/common/ui/Icon/Icon'
import { Modal } from '@/common/ui/Modal'
import { OZON_AUTH_MODAL_ID } from '../../lib/ozonAuth'
import { useOzonLogin } from '../../model/ozonLogin'

export const OzonLoginButton = () => {
    const { isLoading, handleOzonLoginClick, handleCancelOzonLogin } = useOzonLogin()

    return (
        <>
            <Button
                type='button'
                variant='outline'
                emphasis='secondary'
                size='xl'
                className='w-full gap-2'
                disabled={isLoading}
                loading={isLoading}
                aria-label='Войти с помощью Ozon Seller Id'
                onClick={handleOzonLoginClick}
            >
                <Icon name='ozon' size='md' aria-hidden />
                Войти с помощью Ozon Seller Id
            </Button>

            <Modal id={OZON_AUTH_MODAL_ID} showCloseButton={false} aria-label='Авторизация через Ozon'>
                <div className='flex flex-col items-center gap-4 py-2 text-center'>
                    <p className='text-base'>Идёт авторизация через Ozon…</p>
                    <p className='text-sm text-base-content/70'>
                        Завершите вход во всплывающем окне. Если окно не открылось, разрешите всплывающие окна в
                        браузере.
                    </p>
                    <Button
                        type='button'
                        variant='ghost'
                        emphasis='secondary'
                        size='md'
                        onClick={handleCancelOzonLogin}
                    >
                        Отмена
                    </Button>
                </div>
            </Modal>
        </>
    )
}
